import React, { useEffect, useMemo, useState } from 'react';
import { MapContainer, Marker, Popup, TileLayer, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

const DEFAULT_CENTER = { lat: 18.7883, lng: 98.9853 };

// Fix Leaflet's default marker image path to prevent 404 in CRA/Webpack bundles.
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

function RecenterMap({ position, zoom }) {
  const map = useMap();

  useEffect(() => {
    map.setView(position, zoom, { animate: true });
  }, [map, position, zoom]);

  return null;
}

function Map({ address, latitude, longitude, detail, setLatitude, setLongitude }) {
  const parsedLatitude = Number(latitude);
  const parsedLongitude = Number(longitude);

  const initialPosition = useMemo(() => {
    if (Number.isFinite(parsedLatitude) && Number.isFinite(parsedLongitude)) {
      return { lat: parsedLatitude, lng: parsedLongitude };
    }

    return DEFAULT_CENTER;
  }, [parsedLatitude, parsedLongitude]);

  const [markerPosition, setMarkerPosition] = useState(initialPosition);

  useEffect(() => {
    setMarkerPosition(initialPosition);
  }, [initialPosition]);

  const markerEventHandlers = useMemo(
    () => ({
      dragend(event) {
        const marker = event.target;
        const { lat, lng } = marker.getLatLng();
        setMarkerPosition({ lat, lng });
        setLatitude(lat);
        setLongitude(lng);
      },
    }),
    [setLatitude, setLongitude]
  );

  return (
    <MapContainer
      center={markerPosition}
      zoom={13}
      style={{ width: '100%', height: '480px', borderRadius: '18px' }}
      scrollWheelZoom={true}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      <RecenterMap position={markerPosition} zoom={13} />

      <Marker position={markerPosition} draggable={true} eventHandlers={markerEventHandlers}>
        <Popup>
          <div>
            <p>{detail}</p>
            <p>{address}</p>
            <p>Latitude: {markerPosition.lat.toFixed(6)}</p>
            <p>Longitude: {markerPosition.lng.toFixed(6)}</p>
          </div>
        </Popup>
      </Marker>
    </MapContainer>
  );
}

export default React.memo(Map);
